import {getDateFromIsoString} from '@shared/api';
import {KycRecord, KycStatus} from '../types';
import {KycRecordOnBackend} from './backendTypes';

export const mapKycRecordFromBackend = ({
  account_id,
  provider,
  registered_at,
  country,
  status,
  decline_reason,
}: KycRecordOnBackend): KycRecord => ({
  accountId: account_id,
  provider,
  registeredAt: getDateFromIsoString(registered_at),
  country,
  status: status as KycStatus,
  declineReason: decline_reason ?? '',
});
